import { render } from "./infoPopup.vue?vue&type=template&id=be2167ec&ts=true"
import script from "./infoPopup.vue?vue&type=script&lang=ts"
export * from "./infoPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__